<div class="op-error-panel op-pad-16" *ngIf="errorMessage">
	<ng-container *transloco="let t">
		<div class="error-message">
			<mat-icon [svgIcon]="icon"></mat-icon>
			<span class="op-ml-5" [ngClass]="{ 'op-black-bold': highlightMessage }">{{ t(errorMessage) }}</span>
		</div>
		<span *ngIf="errorNote" class="error-note op-mt-8">
			{{ t(errorNote) }}
		</span>
	</ng-container>
</div>
